import React, { useEffect } from 'react';
import { Line } from 'react-chartjs-2';
import { Box } from '@mui/material';
import 'chart.js/auto';

import {
  Chart as ChartJS,
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Tooltip,
  Legend
} from 'chart.js';
import { CRP_STATES, CRP} from '../services/util';
ChartJS.register(
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Tooltip,
  Legend
);

const hexToRgba = (hex, alpha) => {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

const baseColors = ["#305CCB", "#7c91a2", "#A33600", "#d59084", "#0C141D", "#E0C200", "#ff992b", "#ffde19", "#FFADAD"];

const LineGraphVisualization = ({ data, indicators, crp }) => {
  let chartData;
  let options;
  if (crp) {
    chartData = {
      labels: data.map(item => new Date(item.Month).toLocaleDateString(undefined, { year: 'numeric', month: 'short' })),
      datasets: CRP_STATES.map((state, index) => ({
        label: state.label,
        pointRadius: 5,
        pointHoverRadius: 10,
        data: data.map(item => state.label === CRP.label ? item[CRP.name] : item[state.label]),
        borderColor: baseColors[index % baseColors.length],
        backgroundColor: hexToRgba(baseColors[index % baseColors.length], 0.4),
        fill: false,
      })),
    };
  } else {
    chartData = {
      labels: data.map(item => new Date(item.Month).toLocaleDateString(undefined, { year: 'numeric', month: 'short' })),
      datasets: indicators.map((indicator, index) => ({
        label: indicator.label,
        pointRadius: 5,
        pointHoverRadius: 10,
        data: data.map(item => item[indicator.label] !== '-' ? item[indicator.label] : null),
        borderColor: baseColors[index],
        backgroundColor: hexToRgba(baseColors[index], 0.4),
        fill: false,
      }))
    };
  }

  options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      datalabels: {
        display: false,
      },
      legend: {
        position: 'left',
        labels: {
          usePointStyle: true,
        },
        title: {
          display: true,
          text: 'Click to add/remove',
          padding: 10
        },
        font: {
          size: 12
        }
      },
      tooltip: {
        mode: 'point',
        intersect: true,
      },
    },
    hover: {
      mode: 'nearest',
      intersect: true,
    },
    scales: {
      x: {
        display: true,
        grid: {
          display: true,
          drawOnChartArea: true,
          drawTicks: true,
        },
        ticks: {
          display: true,
          suggestedMin: 0,
          autoSkip: true,
        },
      },
      y: {
        display: true,
        title: {
          display: true,
        },
        grid: {
          display: true,
          drawOnChartArea: true,
          drawTicks: true,
        },
        beginAtZero: true,
        ticks: {
          display: true,
          autoSkip: true,
        }
      },
    },
  };

  useEffect(() => {
    const handleResize = () => {
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <Box className="line-graph-container">
      <Line data={chartData} options={options} />
    </Box>
  );
};

export default LineGraphVisualization;
